import { ResponsiveContainer } from "recharts"
import Button from "../../Buttons/Button"

interface ActionCardProps {
    image: string
    alt: string
    title: string
    description: string
    buttonLabel: string
    onClick: () => void
    buttonDisabled: boolean;
}

const ActionCard = ({
    image,
    alt,
    title,
    description,
    buttonLabel,
    onClick,
    buttonDisabled
}: ActionCardProps) => {
    return (
        <main className="flex flex-col items-center">
            <ResponsiveContainer>
                <div className="flex flex-col gap-6 items-center my-10">
                    <img src={image} alt={alt} />
                    <div className="flex flex-col gap-6 items-center w-full md:w-[40rem]">
                        <h1 className="text-brand-green-20 text-hsmall text-center">{title}</h1>
                        <p className="text-primary-10 text-blarge text-center">{description}</p>
                        <Button 
                            label={buttonLabel}
                            onClick={onClick}
                            showIconLeft={false}
                            showIconRight={false}
                            disabled={buttonDisabled}
                            variant="primary"
                        />
                    </div>
                </div>
            </ResponsiveContainer>
        </main>
    )
}

export default ActionCard